<p-dialog [(visible)]="driversService.modalEnrollmentActive" [modal]="true" [resizable]="true" [style]="{width: '90vw', 'max-width': '1000px', height : 'auto'}">

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingListDriverEnroll" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="false">
    <div class="mt-2" style="color: white; text-align: center;">
      <p style="margin: 4px 0;">Esperando respuesta del dispositivo...</p>
      <small style="opacity: 0.8;">Cargando... incluso las mejores plataformas necesitan café.</small>
    </div>
  </ngx-spinner>

  <ng-template pTemplate="header" class="p-dialog-title">Enrolamiento de Conductores - CIPIA</ng-template>
  <div class="p-0">

    <div class="row mb-4">
      <div class="container">
        <div class="row mb-3 align-items-center">
          <div class="col-4 fw-bold text-start mb-2 mb-md-0">
            <label for="list-drivers">Seleccionar un Vehículo:</label>
          </div>

          <div class="col-8">
            <p-dropdown [options]="filteredUnits" [(ngModel)]="selectedUnit" optionLabel="unitName" dataKey="GNSSIMEI"
              placeholder="Selecciona un vehículo" (onChange)="selectVehicleUnit()" [filter]="true" [showClear]="true"
              [style]="{ width: '100%' }">
              <ng-template let-option pTemplate="item">
                <div style="display: flex; align-items: center;">
                  <span [style.background-color]="option.transmissionStatusColor"
                    style="width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;">
                  </span>
                  {{ option.unitName }}
                </div>
              </ng-template>
            </p-dropdown>
            <p-tooltip *ngIf="filteredUnits?.length > 0" target=".p-dropdown" [style]="{maxWidth: '300px'}">
              Vehículos disponibles: {{ filteredUnits.length }} opciones
            </p-tooltip>
          </div>
        </div>
      </div>

    </div>
    <div class="flex-column mt-3">
      <div class="row gl-listbox-container">
        <div class="col">
          <h5>Lista General de Conductores </h5>
          <!-- Menú contextual -->
          <p-contextMenu #cm [model]="menuItemsConductores" appendTo="body"></p-contextMenu>
          <input pInputText type="text" placeholder="Buscar conductor"
            (input)="dt.filterGlobal($event.target.value, 'contains')" style="margin-bottom: 10px; width: 100%;" />
          <div style="
              height: 220px;
              overflow: hidden;
              position: relative;"
            >
            <div class="table-overlay" *ngIf="!contextMenuDriverEnabled"></div>          

            <p-table #dt [value]="listDriversFull" [(contextMenuSelection)]="selectedDriver" [contextMenu]="cm"
              selectionMode="single" [scrollable]="true" scrollHeight="200px" [paginator]="false" dataKey="key_number"
              styleClass="p-datatable-sm p-datatable-striped" [globalFilterFields]="['name_driver', 'key_number']">
              <ng-template pTemplate="body" let-driver>
                <tr [pContextMenuRow]="driver"
                  (click)="onDriverRowClick(driver)"
                 [ngClass]="{ 'selected-row': selectedDriver?.key_number === driver.key_number }">
                  <td>
                    <div class="d-flex justify-content-between align-items-center w-100">
                      <span style="font-size: 12px;">
                        {{ driver.name_driver + ' - ' + driver.key_number }}
                      </span>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <small class="p-2"><i class="fas fa-list"></i>&nbsp;Conductores Disponibles ({{ listDriversFull.length
            }})</small>
        </div>



        <div class="col-1 d-flex flex-column justify-content-center align-items-center">
          <div style="height: 1.5rem"></div>
          <div class="">
            <button (click)="sendListDriversToEnrollment()" type="button" class="btn-gl-light-blue btn-circle"
              name="button" 
              [disabled]="listDriversFull.length === 0 || !hasEnrolledInDriversList || !selectedDriver"

               [pTooltip]="'Enrolar Conductor'">
              <span>
                <i class="fa fa-arrow-right fa-lg" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div style="height: 1rem"></div>
          <div class="">
            <button (click)="returnListDriversFull()" type="button" class="btn-gl-light-blue btn-circle" name="button"
              [disabled]="listDriverEnrolled.length === 0 || !hasUnrolledInEnrollmentList || !selectedDriversEnrolled"
              
              [pTooltip]="'Remover Conductor'">
              <span>
                <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
              </span>
            </button>
          </div>
        </div>




        <div class="col">
          <h5>Lista de Enrolamientos</h5>


          <!-- Menú contextual para la tabla de conductores enrolados -->
          <p-contextMenu #cmEnrolled [model]="menuItemsEnrolled" appendTo="body"></p-contextMenu>

          <!-- Input de búsqueda -->
          <input pInputText type="text" placeholder="Buscar conductor enrolado"
            (input)="dtEnrolled.filterGlobal($event.target.value, 'contains')"
            style="margin-bottom: 10px; width: 100%;" />
          <div style="
              height: 220px;
              overflow: hidden;
              position: relative;"
          >
          <div class="table-overlay" *ngIf="!contextMenuEnrolledEnabled"></div>          
          <p-table #dtEnrolled [value]="listDriverEnrolled" [(contextMenuSelection)]="selectedDriversEnrolled"
            [contextMenu]="cmEnrolled" selectionMode="single" [scrollable]="true" scrollHeight="200px"
            [paginator]="false" dataKey="key_number" styleClass="p-datatable-sm p-datatable-striped"
            [globalFilterFields]="['name_driver', 'key_number']"
            (onContextMenuSelect)="onContextMenuSelect($event)">

            <ng-template pTemplate="body" let-driver>
              <tr [pContextMenuRow]="driver" 
                [ngClass]="{
                  'row-enrolar': driver.type === 'enrolar',
                  'row-desenrolar': driver.type === 'desenrolar',
                  'status-loading': driver.status === 'loading',
                  'status-error': driver.status === 'error',
                  'status-success': driver.status === 'success',
                  'status-waiting': driver.status === 'waiting',
                  'selected-enrolled-row': selectedDriversEnrolled?.key_number === driver.key_number,
                  'selected-row': selectedDriver?.key_number === driver.key_number
                }"
                  (click)="onDriverEnrolledRowClick(driver)"
                >
                
                <td class="driver-cell d-flex flex-row justify-content-between align-items-centertems-center gap-4">

                  <!-- 🟢 Icono de tipo al inicio -->
                  <div class="d-flex flex-row items-center align-items-center gap-2 justify-content-center">
                    <i 
                      [ngClass]="{
                        'pi': true,
                        'pi-sign-in': driver.type === 'enrolar',
                        'pi-sign-out': driver.type === 'desenrolar',
                        'text-green-600': driver.type === 'enrolar',
                        'text-orange-600': driver.type === 'desenrolar'
                      }"
                      title="{{ driver.type === 'enrolar' ? 'Enrolar' : 'Desenrolar' }}"
                      style="font-size: 1.4rem;"
                    ></i>

                    <div>
                      <div style="font-size: 12px;">{{ driver.name_driver + ' - ' + driver.key_number }}</div>
                      <div style="font-size: 11px;" 
                        [ngClass]="{
                          'text-green-600': driver.type === 'enrolar',
                          'text-orange-600': driver.type === 'desenrolar'
                        }">
                        {{ driver.type === 'enrolar' ? 'Enrolado' : 'Desenrolado' }}
                      </div>
                      <div *ngIf="driver.errorMessage" class="text-error">
                        {{driver.errorMessage}}
                      </div>
                    </div>
                  </div>

                  <!-- ⚠️ Icono de estado al final -->
                  <!-- Botón eliminar (solo error) -->
                  <button
                    *ngIf="driver.status === 'error'"
                    type="button"
                    (click)="onRemoveDriver(driver)"
                    class="p-0 border-0 bg-transparent"
                    style="font-size: 1.4rem; cursor: pointer;"
                    title="Eliminar de la lista"
                  >
                    <i class="pi pi-times text-red-500"></i>
                  </button>

                  <!-- Icono estado para otros estados -->
                  <i 
                    *ngIf="driver.status !== 'error'"
                    style="font-size: 1.4rem"
                    [ngClass]="{
                      'pi': true,
                      'pi-clock': driver.status === 'waiting',
                      'pi-spin pi-spinner': driver.status === 'loading',
                      'pi-check-circle': driver.status === 'success',
                      'text-yellow-500': driver.status === 'waiting',
                      'text-blue-500': driver.status === 'loading',
                      'text-green-500': driver.status === 'success'
                    }"
                    [title]="{
                      waiting: 'Esperando...',
                      loading: 'Cargando...',
                      success: 'Completado'
                    }[driver.status]"
                  ></i>
                </td>

              </tr>
            </ng-template>
          </p-table>

          </div>

          <div class="d-flex flex-row">            
            <small class="p-2" (dblclick)="showHistoryPanel()"><i class="fas fa-user-check"></i>&nbsp;Pendientes ({{ listDriverEnrolled.length }})</small>
            <small class="p-2" ><i class="fas fa-user-check"></i>&nbsp;
              Conductores Enrolados ({{ filteredDriverEnrolled + driversUnknown }} / 20)
              <i *ngIf="driversUnknown>0" class="fas fa-exclamation-triangle fa-lg" style="color: red;"
                [pTooltip]="this.messageDriversUnknown"></i></small>
          </div>
        </div>

      </div>
    </div>


    <div *ngIf="showHistorial">

      <div *ngIf="transformedHistory.length > 0; else noData">
        <p-accordion [multiple]="true" class="custom-accordion">
          <p-accordionTab 
            *ngFor="let entry of transformedHistory" 
            [header]="'Vehículo IMEI: ' + entry.imei"
            [style.padding]="'0.5rem'"
          >
            <ul class="history-list p-0 m-0 list-none">
              <li 
                *ngFor="let req of entry.requests"
                class="history-item flex items-center justify-between p-3 mb-2 rounded"
                [ngClass]="{
                  'status-waiting': req.data.status === 'waiting',
                  'status-loading': req.data.status === 'loading',
                  'status-success': req.data.status === 'success',
                  'status-error': req.data.status === 'error'
                }"
              >
                <div class="driver-info flex items-center gap-3">
                  <i 
                    [ngClass]="{
                      'pi': true,
                      'pi-clock': req.data.status === 'waiting',
                      'pi-spin pi-spinner': req.data.status === 'loading',
                      'pi-check-circle': req.data.status === 'success',
                      'pi-times-circle': req.data.status === 'error'
                    }"
                    [title]="{
                      waiting: 'Esperando...',
                      loading: 'Enviando...',
                      success: 'Guardado exitosamente',
                      error: 'Error al guardar'
                    }[req.data.status]"
                    class="status-icon"
                  ></i>
                  <span class="driver-id font-semibold text-base">
                    Driver ID: {{ req.driverID }}
                  </span>
                </div>
              </li>
            </ul>
          </p-accordionTab>
        </p-accordion>
      </div>

      <ng-template #noData>
        <p class="text-sm text-gray-500 italic">No hay historial disponible.</p>
      </ng-template>

    </div>

  </div>


  <ng-template class="p-dialog-content" pTemplate="content">

    <div class="row justify-content-center mb-4 pt-2 panel-izq-container-footer">
      <div class="col-4">
        <button type="button" class="btn-gl-cancel btn-dark-hover w-100"
          (click)="driversService.modalEnrollmentActive=false">Cerrar</button>
      </div>
    </div>
  </ng-template>

</p-dialog>